import React, { FC } from 'react'
import classNames from 'classnames'
import { Button } from '@/atoms/Button'
import { SeatOutlineIcon } from '@/atoms/Icons/SeatOutlineIcon'
import { CaptionMD } from '@/atoms/Text'
import { useSafeTrack } from '@/utils/analytics'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface CheckSeatAvailabilityButtonProps {
  className?: string
  buttonText: string
  onClick: () => void
}

export const CheckSeatAvailabilityButton: FC<CheckSeatAvailabilityButtonProps> = ({
  className,
  buttonText,
  onClick,
}) => {
  const track = useSafeTrack()

  const handleClick = () => {
    track('Clicked Seat Availability Button')
    onClick()
  }

  return (
    <Button
      onClick={handleClick}
      size="sm"
      variant="core-gray-900"
      outline
      className={classNames(
        'group flex items-center gap-1 whitespace-nowrap outline outline-1 outline-core-gray-950',
        className,
      )}
    >
      <SeatOutlineIcon size={15} className="shrink-0 *:group-hover:fill-white" />
      {buttonText}
    </Button>
  )
}

export const CheckSeatAvailabilityButtonWrapper: FC<CheckSeatAvailabilityButtonProps> = (props) => {
  const { t } = useTranslate('tickets')

  return (
    <div className="mt-6 flex items-center gap-4 border-t border-core-gray-300 pt-4 lg:hidden">
      <CaptionMD>
        <Translate t={t} i18nKey="compareSeatAvailabilityAcrossShowtimes">
          Compare <b>Seat Availability</b> across showtimes
        </Translate>
      </CaptionMD>
      <CheckSeatAvailabilityButton {...props} />
    </div>
  )
}
